// ** Routes Imports
import DashboardRoutes from './Dashboards';

// import FormRoutes from './Forms';
import PagesRoutes from './Pages';
import PageLayoutsRoutes from './PageLayouts';

import MySocialRoutes from './MySocial';
import CommunityRoutes from './Community';
import ComponentsRoutes from './Components';
import {CoursesRoutes} from "./Courses";

// ** Document title
const TemplateTitle = '%s - MyManager React Admin Template';

// ** Default Route
const DefaultRoute = '/community/home';

// ** Merge Routess
const Routes = [
  ...DashboardRoutes,
  ...PagesRoutes,
  ...MySocialRoutes,
  ...CommunityRoutes,
  ...ComponentsRoutes,
  ...CoursesRoutes
];

export { DefaultRoute, TemplateTitle, Routes };
